import React from 'react'
import PropTypes from 'prop-types'
import focusable from '../../components/Focusable/Focusable'

class ToggleSwitch extends React.Component {
  constructor(props) {
    super(props)

    this.componentType = props.componentType
  }

  onKeyEvent(key) {
    let handled = false
    if (key === 'LEFT') {
      if (this.props.defaultSelected === 'first-option') return
      this.props.onToggle()
      handled = true
    }
    if (key === 'RIGHT') {
      if (this.props.defaultSelected === 'second-option') return
      this.props.onToggle()
      handled = true
    }
    return handled
  }

  render() {
    const { hasFocus, className } = this.props
    return (
      <div
        className={`toggle-container ${className} ${
          hasFocus ? 'toggle-container--active' : 'toggle-container--inactive'
        }`}
      >
        <div>
          {this.props.options.map((option) => {
            return (
              <span
                key={option.id}
                className={`toggle-container__${option.id} toggle-container__${
                  option.id === this.props.defaultSelected ? 'active-' : ''
                }option`}
              >
                {option.value}
              </span>
            )
          })}
        </div>
        <div>
          <input
            type="checkbox"
            className={`toggle-container__toggler-checkbox ${this.props.defaultSelected}`}
          />
          <label className="toggle-container__toggler-label" htmlFor="toggle" />
        </div>
      </div>
    )
  }
}

ToggleSwitch.propTypes = {
  componentType: PropTypes.string,
  options: PropTypes.array,
  className: PropTypes.string,
  hasFocus: PropTypes.bool,
  onToggle: PropTypes.func,
  defaultSelected: PropTypes.string,
}

ToggleSwitch.defaultProps = {
  className: '',
}

export default focusable(ToggleSwitch)
